import { useCallback } from 'react';

import { useModal, AuthModalOptions, useUserContext } from '../contexts';

/**
 * Хук для выполнения действий, требующих авторизации
 * Если пользователь не авторизован, показывает модальное окно авторизации
 */
export const useWithAuth = () => {
    const { auth } = useModal();
    const { user } = useUserContext();

    const withAuth = useCallback(
        (action: () => void, options?: AuthModalOptions) => {
            if (!user.isAuth) {
                auth.open(options);

                return;
            }

            action();
        },
        [user.isAuth, auth],
    );

    return {
        withAuth,
    };
};
